// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  accAnnounceMovedKey: (p: { itemKey: string; position: string; referenceKey: string }) =>
    'Перемещено ' + p['itemKey'] + ' ' + p['position'] + ' ' + p['referenceKey'] + '.',
  accButtonProgressComplete: (p: { label: string }) => 'Действие ' + p['label'] + ' выполнено',
  accButtonProgressStatus: (p: { label: string }) => 'Действие ' + p['label'] + ' выполняется',
  accColorPalette: () => 'Цветов.Палитра',
  accColorSwatch: () => 'Образец цвета',
  accCommandKey: () => 'Команда',
  accContextMenuLabel: () => 'действия',
  accControlKey: () => 'Закрыть',
  accPositionAfter: () => 'после',
  accPositionBefore: () => 'до',
  accReorderInstructions: (p: { keyPressed: string }) =>
    'Нажмите и удерживайте клавиши ' +
    p['keyPressed'] +
    ' и Shift, а затем воспользуйтесь клавишами со стрелками для изменения порядка.',
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Укажите полную дату, как в этом примере: ' + p['dateExample'] + '.',
  calendarMonthConverter_parseError: (p: { dateExample: string }) =>
    'Укажите месяц и год, как в этом примере: ' + p['dateExample'] + '.',
  chart_labelDataLabel: () => 'Метка',
  chart_labelGroup: () => 'Группа',
  chart_labelSeries: () => 'Серия',
  chart_labelValue: () => 'Значение',
  chart_labelWidthWeight: () => 'Z',
  chart_labelX: () => 'X',
  chart_labelY: () => 'Y',
  checkboxSet_requiredMessageDetail: () => 'Выберите значение.',
  checkbox_helpForCheckbox: () => 'Справка для флажка',
  checkbox_requiredMessageDetail: () => 'Выберите значение.',
  checkbox_selected: () => 'Флажок установлен',
  checkbox_unselected: () => 'Флажок не установлен',
  close: () => 'Закрыть',
  collection_apply: () => 'Применить',
  collection_cancel: () => 'Отмена',
  collection_loaded: () => 'Загружено',
  collection_loading: () => 'Загрузка',
  collection_noData: () => 'Нет данных для отображения.',
  collection_pixels: () => 'пикс.',
  collection_resizeColumnDialog: () => 'Изменить размер столбца',
  collection_resizeColumnMenu: () => 'Изменить размер столбца...',
  collection_resizeMessageDetail: (p: { MIN: string; MAX: string }) =>
    'Введите число от ' + p['MIN'] + ' до ' + p['MAX'] + '.',
  collection_selectAllRows: () => 'Выбрать все строки',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Выбрать строку ' + p['ROW_NAME'],
  collection_sortAscendingSubMenu: () => 'По возрастанию',
  collection_sortColumnMenu: () => 'Сортировать столбец',
  collection_sortDescendingSubMenu: () => 'По убыванию',
  collection_sortDisabled: () => 'Сортировка невозможна',
  collection_sortEnabled: () => 'Доступно для сортировки',
  collection_width: () => 'Ширина',
  colorPicker_label: () => 'Выбор цвета',
  confirmation: () => 'Подтверждение',
  datePicker_currentDate: () => 'Текущая дата',
  datePicker_goToToday: () => 'Перейти к текущему дню',
  datePicker_label: () => 'Выбор даты',
  datePicker_month: () => 'Месяц',
  datePicker_months: () => 'Месяцы',
  datePicker_next: () => 'Далее',
  datePicker_nextDecade: () => 'Следующая декада',
  datePicker_nextMonth: () => 'Следующий месяц',
  datePicker_prev: () => 'Назад',
  datePicker_prevDecade: () => 'Предыдущая декада',
  datePicker_prevMonth: () => 'Предыдущий месяц',
  datePicker_restricted: () => 'Запрещено',
  datePicker_selected: () => 'Выбрано',
  datePicker_today: () => 'Сегодня',
  datePicker_weekNum: (p: { NUM: string }) => 'Неделя ' + p['NUM'],
  datePicker_weekNumColLabel: () => 'Номер недели',
  datePicker_year: () => 'Год',
  datePicker_years: () => 'Годы',
  diagram_promotedLink: () => '1 ссылка',
  diagram_promotedLinkAriaDesc: () => 'Косвенные',
  diagram_promotedLinks: (p: { num_links: string }) => 'Ссылки ' + p['num_links'],
  error: () => 'Ошибка',
  expandableList_expandCollapseInstructionText: () =>
    'Для развертывания и свертывания используйте клавиши со стрелками',
  expandableList_groupCollapse: () => 'Свернуто',
  expandableList_groupExpand: () => 'Развернуто',
  filePicker_addFiles: () => 'Добавить файлы',
  filePicker_dropzonePrimaryText: () => 'Добавьте файлы',
  filePicker_dropzoneSecondaryText: () => 'Выберите или перетащите файл сюда',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Выберите или перетащите файлы сюда',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Невозможна загрузка файлов следующих типов: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Загружайте по одному файлу за один раз',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Загрузка файлов типа ' + p['fileType'] + ' невозможна',
  filePicker_unknownFileTypeUploadError: () => 'неизвестно',
  formControl_clear: () => 'Очистить',
  formControl_day: () => 'День',
  formControl_empty_segment: () => 'Пусто',
  formControl_helpAvailable: () => 'Доступна справка',
  formControl_hide: () => 'Скрыть',
  formControl_hour: () => 'Час',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Достигнут лимит в ' +
    ((
      {
        one: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символ',
        few: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символа',
        many: new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символов'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ru').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ru').format(p['CHARACTER_LIMIT']) + ' символов') +
    '.',
  formControl_loading: () => 'Загрузка',
  formControl_maxLength: (p: { MAX_LENGTH: string }) =>
    'Можно ввести до ' + p['MAX_LENGTH'] + ' символов.',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Превышена максимальная длина ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Осталось символов: ' + p['CHARACTER_COUNT'] + '.',
  formControl_millisecond: () => 'Миллисекунда',
  formControl_minute: () => 'Минута',
  formControl_month: () => 'Месяц',
  formControl_readOnly: () => 'Только для чтения',
  formControl_requiredMessageDetail: () => 'Введите значение.',
  formControl_second: () => 'Секунда',
  formControl_selectionExactMessageDetail: (p: { n: string }) =>
    'Выберите значения (' + p['n'] + ').',
  formControl_selectionOverflowMessageDetail: (p: { max: string }) =>
    'Выбрано предельное количество (' + p['max'] + ').',
  formControl_selectionRangeMessageDetail: (p: { min: string; max: string }) =>
    'Выберите значения (от ' + p['min'] + ' до ' + p['max'] + ').',
  formControl_selectionUnderflowMessageDetail: (p: { min: string }) =>
    'Минимальное количество значений для выбора: ' + p['min'] + '.',
  formControl_show: () => 'Показать',
  formControl_year: () => 'Год',
  gantt_labelDate: () => 'Дата',
  gantt_labelEnd: () => 'Окончание',
  gantt_labelLabel: () => 'Метка',
  gantt_labelRow: () => 'Строка',
  gantt_labelStart: () => 'Начало',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Соответствующий раздел не найден.',
  indexer_keyboardInstructionText: () => 'Нажмите Enter, чтобы выбрать значение.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'С ' + p['FROM_SECTION'] + ' по ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Дважды коснитесь и удерживайте, чтобы перейти в режим жестов, затем перетащите вверх или вниз, чтобы изменить значение.',
  info: () => 'Информация',
  inputColor_selectColor: () => 'Выбрать цвет',
  inputDateMask_date_cleared: () => 'Дата удалена',
  inputDateMask_dayPlaceholder: () => 'дд',
  inputDateMask_empty_segment: () => 'Пусто',
  inputDateMask_monthPlaceholder: () => 'мм',
  inputDateMask_yearPlaceholder: () => 'гггг',
  inputDatePicker_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введите дату не позже ' + p['max'] + '.',
  inputDatePicker_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введите дату не ранее ' + p['min'] + '.',
  inputDatePicker_dateRestrictionMessageDetail: () => 'Введите доступную дату.',
  inputDatePicker_instruction: () => 'Для доступа к календарю нажмите Tab.',
  inputDatePicker_selectDate: () => 'Выбрать дату',
  inputMonthMask_dateRangeOverflowMessageDetail: (p: { max: string }) =>
    'Укажите месяц и год, которые наступают не позднее, чем ' + p['max'] + '.',
  inputMonthMask_dateRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Укажите месяц и год, которые наступают не ранее, чем ' + p['min'] + '.',
  inputNumber_converterParseError: () => 'Введите число.',
  inputNumber_decrease: () => 'Уменьшить',
  inputNumber_increase: () => 'Увеличить',
  inputPassword_hidden: () => 'Пароль скрыт',
  inputPassword_hide: () => 'Скрыть пароль',
  inputPassword_show: () => 'Показать пароль',
  inputSensitiveText_hidden: () => 'Конфиденциальный текст скрыт',
  inputTimeMask_timeRangeOverflowMessageDetail: (p: { max: string }) =>
    'Введите время не позднее ' + p['max'] + '.',
  inputTimeMask_timeRangeUnderflowMessageDetail: (p: { min: string }) =>
    'Введите время не ранее ' + p['min'] + '.',
  inputTimeMask_time_cleared: () => 'Время очищено',
  labelNone: () => 'Нет',
  list_msgFetchCompleted: () => 'Загружено',
  list_msgFetchingData: () => 'Загрузка',
  list_suggestion: () => 'Предложение',
  menu_stateLoading: () => 'Загрузка',
  messageToast_allMessagesClosed: () => 'Все всплывающие сообщения-подсказки закрыты.',
  message_close: () => 'Закрыть',
  message_confirmation: () => 'Завершено',
  message_error: () => 'Ошибка',
  message_info: () => 'Информация',
  message_navigationFromMessagesRegion: () => 'Вход в область сообщений. Нажмите F6 для перехода.',
  message_navigationToMessagesRegion: () =>
    'Область сообщений содержит новые сообщения.  Нажмите F6 для перехода.',
  message_navigationToTouch: () => 'Область сообщений содержит новые сообщения.',
  message_warning: () => 'Предупреждение',
  noData_message: () => 'Нет элементов для отображения',
  overflowItemLabel: () => 'Больше вкладок',
  plural_separator: () => ', ',
  popup_close_skipLink: () => 'Дважды коснитесь, чтобы закрыть открытое всплывающее окно.',
  popup_liveRegion_F6_initial_focus_firstFocusable: () =>
    'Вход во всплывающее окно. Нажмите F6 для перехода между всплывающим окном и связанным элементом управления.',
  popup_liveRegion_F6_initial_focus_none: () =>
    'Открыто всплывающее окно. Нажмите F6 для перехода между всплывающим окном и связанным элементом управления.',
  progressIndeterminate: () => 'Выполняется',
  radioButton_checked: () => 'Переключатель установлен',
  radioButton_selected: () => 'Переключатель выбран',
  radioButton_unchecked: () => 'Переключатель не установлен',
  radioButton_unselected: () => 'Переключатель не выбран',
  radio_helpForRadio: () => 'Справка по переключателю',
  radio_requiredMessageDetail: () => 'Выберите значение.',
  selectMultiple_apply: () => 'Применить',
  selectMultiple_back: () => 'Назад',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_highlightSelectedTagsInstructionText: () =>
    'Используйте клавиши со стрелками влево и вправо для выделения выбранных значений.',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Нажмите клавишу Backspace или Delete, чтобы удалить выбранное значение.',
  selectMultiple_selectedValues: () => 'Выбранные значения',
  selectMultiple_showSelectedValues: () => 'Показать только выбранные значения.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Выбрано значений: ' + p['VALUE_COUNT'] + '.',
  select_addToList: () => 'Добавить в список',
  select_addToListAvailable: () => 'Доступно "Добавить в список"',
  select_closeDropdown: () => 'Нажмите Escape, чтобы закрыть.',
  select_moreSearchOptions: () => 'Дополнительные параметры поиска',
  select_moreSearchOptionsAvailable: () => 'Доступны дополнительные параметры поиска',
  select_noMatchesFound: () => 'Совпадений не найдено.',
  select_oneMatchFound: () => 'Найдено одно совпадение',
  select_requiredMessageDetail: () => 'Выберите значение.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Найдено совпадений: ' + p['TOTAL_SIZE'],
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Найдено совпадений: ' + p['TOTAL_SIZE'] + ' или более',
  selectorAll_deselectAll: () => 'Отменить выбор',
  selectorAll_selectAll: () => 'Выбрать все',
  selector_selected: () => 'Флажок установлен',
  selector_unselected: () => 'Флажок не установлен',
  sheet_close: () => 'Закрыть',
  switch_off: () => 'Выкл.',
  switch_on: () => 'Вкл.',
  tabBarNavigationList_removeCueText: () => 'Для удаления',
  tabBar_tabContainsErrors: () => 'Содержит ошибки',
  tabbar_accAnnounceRemovedKey: (p: { itemKey: string }) => 'Удалено: ' + p['itemKey'],
  tabbar_labelContextMenu: () => 'содержит контекстное меню',
  tabbar_labelMoveLeft: () => 'Переместить влево',
  tabbar_labelMoveRight: () => 'Переместить вправо',
  tabbar_labelRemove: () => 'Удалить',
  timeComponent_tooltipZoomIn: () => 'Увеличить',
  timeComponent_tooltipZoomOut: () => 'Уменьшить',
  timeConverter_parseError: () => 'Введите полное время.',
  train_current: () => 'Текущий',
  train_message_type: () => 'Тип сообщения',
  train_not_visited: () => 'Не посещено',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Шаг ' + p['currentStep'] + ' из ' + p['numberOfSteps'],
  train_visited: () => 'Посещено',
  userAssistance_learnMore: () => 'Дополнительные сведения',
  userAssistance_required: () => 'Обязательно',
  vis_clearSelection: () => 'Отменить выбор',
  vis_drillable: () => 'С возможностью детализации',
  vis_invalidData: () => 'Недопустимые данные',
  vis_labelAndValue: (p: { LABEL: string; VALUE: string }) => p['LABEL'] + ': ' + p['VALUE'],
  vis_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' из ' + p['totalCount'],
  vis_marqueeSelectTooltip: () => 'Выбор выделенной области',
  vis_marqueeZoomTooltip: () => 'Масштабирование выделенной области',
  vis_noData: () => 'Нет данных для отображения',
  vis_panTooltip: () => 'Сдвиг',
  vis_stateCollapsed: () => 'Свернуто',
  vis_stateExpanded: () => 'Развернуто',
  vis_stateLoaded: () => 'Загружено',
  vis_stateLoading: () => 'Загрузка',
  vis_stateSelected: () => 'Выбрано',
  vis_stateUnselected: () => 'Не выбрано',
  warn: () => 'Предупреждение'
};
export default bundle;
